import LoadingIndicator from '../components/Common/LoadingIndicator';
import ConfirmEmailError from '../components/ConfirmEmail/ConfirmEmailError';
import ConfirmEmailSuccess from '../components/ConfirmEmail/ConfirmEmailSuccess';
import useConfirmEmail from '../hooks/auth/useConfirmEmail';

const ConfimEmailPage = () => {
  const { loading, success, error } = useConfirmEmail();
  return (
    <div className='text-center col-lg-8 offset-lg-2 mt-10'>
      {loading && <LoadingIndicator />}
      {error && <ConfirmEmailError errorMessage={error} />}
      {success && <ConfirmEmailSuccess />}
    </div>
  );
};

export default ConfimEmailPage;
